export const COMPLEX_DIALOG_INPUT_DATA = 'complexDialogInputData';
